$(function () {
    var $avatarImage, $avatarInput, $avatarForm,$btnAvatar;

    $avatarImage = $('#imageProfileView');
    $avatarInput = $('#avatarInput');
    $avatarForm = $('#avatarForm');
    $btnAvatar = $('.btnAVatar');

    $avatarImage.on('click', function () {
        $avatarInput.click();
    });

    $avatarInput.on('change', function () {
        console.log('change');
        $avatarForm.submit();
    });

    $btnAvatar.click(function () {
        $avatarForm.submit();
    });

    $avatarForm.on('submit', function (e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('photo', $avatarInput[0].files[0]);
        console.log('ajax');
        $.ajax({
            url: $avatarForm.attr('action') + '?' + $avatarForm.serialize(),
            method: $avatarForm.attr('method'),
            data: formData,
            processData: false,
            contentType: false,
            success: function (datos) {
                if ($.trim(datos) == "1")
                {
                    console.log('ready');
                    location.reload();
                }
                else
                {
                    swal({
                        text: "Error, hubo problemas",
                        icon: "warning",
                        button: "OK!",
                    });
                }
            }
        });

        console.log('finajax');
    });
});

$('#avatarInput').on('change', function(ev) {
    var f = ev.target.files[0];
    fr = new FileReader();

    fr.onload = function(ev2) {
        //console.dir(ev2);
        $('#imageProfileView').attr('src', ev2.target.result);
    };

    fr.readAsDataURL(f);
});